import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SubProductCard from '../common/components/SubProductCard';
import TutelaCirculation from './TutelaLegaleProducts/TutelaCirculation';
import TutelaPatenteMotorFormFlow from './TutelaLegaleProducts/TutelaPatenteMotorFormFlow';
import TutelaNucleoFamigliare from './TutelaLegaleProducts/TutelaNucleoFamigliare';
import TutelaProfessionale from './TutelaLegaleProducts/TutelaProfessionale';

function RcTutelaLegale() {
  const [selectedSubProduct, setSelectedSubProduct] = useState(null);
  const { subProduct } = useParams();

  useEffect(() => {
    if (subProduct) {
      setSelectedSubProduct(subProduct);
    }
  }, [subProduct]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {selectedSubProduct === null && (
        <>
          <div className="quote-group">
            <div className="quote-h1 text-center">
              <h1>NUOVO PREVENTIVO</h1>
            </div>
            <div className="quote-h6">
              <h6>Cosa vuoi proteggere?</h6>
            </div>
          </div>
          <div className="container text-center select-product-one">
            <div className="row justify-content-center g-2 g-md-3 ">
              <SubProductCard
                product="Tutela Legale"
                sub_product="Circolazione"
                onSelect={() => {
                  setSelectedSubProduct('circolazione');
                }}
              />
              <SubProductCard
                product="Tutela Legale "
                sub_product="Patente (Motor)"
                onSelect={() => {
                  setSelectedSubProduct('patente_motor');
                }}
              />
              <SubProductCard
                product="Tutela Legale"
                sub_product="Vita Privata"
                onSelect={() => {
                  setSelectedSubProduct('vita_privata');
                }}
              />
              <SubProductCard
                product="Tutela Legale"
                sub_product="Professionale"
                onSelect={() => {
                  setSelectedSubProduct('tutela_professionale');
                }}
              />
            </div>
          </div>
        </>
      )}
      {selectedSubProduct === 'circolazione' && (
        <TutelaCirculation />
      )}

      {selectedSubProduct === 'patente_motor' && (
        <TutelaPatenteMotorFormFlow />
      )}

      {selectedSubProduct === 'vita_privata' && (
        <TutelaNucleoFamigliare />
      )}
      {selectedSubProduct === 'tutela_professionale' && (
      <TutelaProfessionale />
      )}
    </>
  );
}

export default RcTutelaLegale;
